import BreadcrumbList from '../../Stock/components/Breadcrumb';
import { Button, Card, DatePicker, Menu, Table } from 'antd';
import useDebounce from '@root/core/hooks/useDebounce';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import ShippingServices from '@root/modules/Sellers/Shipping/services/shipping';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import DropdownButton from '../../Inquiry/components/DropdownButton';
import SearchBox from '../../Inquiry/components/Search';
import useTranslate from '@root/core/hooks/useTranslate';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import product from '../../Product/services/product';
import { getStatusSeller } from '../helpers';

interface DataType {
  key: React.Key;
  no: number;
  orderNumber: string;
  buyerName: string;
  productName: string;
  warehouseName: string;
  status: string;
  updated_at: Date;
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const Shipping = () => {
  const [t] = useTranslate();
  const [list, setList] = useState([] as any);
  const history = useHistory();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItem, setTotaItem] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [labelType, setLabelType] = useState({
    key: '2',
    label: t('seller:button:select')
  } as any);
  const [proName, setProName] = useState('');
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [sort, setSort] = useState<boolean>(true);

  const [dateValue, setDateValue] = useState<[string, string]>();
  const fromDt: string = (dateValue && dateValue[0]) || '';
  const toDt: string = (dateValue && dateValue[1]) || '';
  const listBreadcrumb = [
    {
      tittle: '배송 관리',
      url: ''
    },
    {
      tittle: '배송 조회',
      url: ''
    }
  ];
  const columns: ColumnsType<DataType> = [
    {
      title: 'No',
      dataIndex: 'key'
    },
    {
      title: '주문번호',
      dataIndex: 'orderNumber'
    },
    {
      title: '주문자명',
      dataIndex: 'buyerName'
    },
    {
      title: '상품명',
      dataIndex: 'orderProducts',
      render: (orderProducts: any[]) => orderProducts[0]?.productImported?.productName
    },
    {
      title: '물류센터명',
      dataIndex: 'warehouse',
      render: (warehouse: any) => warehouse?.name
    },
    {
      title: '상태',
      dataIndex: 'statusSeller'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          업데이트일
          {!!sort ? (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
              }}
            />
          ) : (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(true)}
            />
          )}
        </div>
      ),
      dataIndex: 'updated_at'
      // key: "updated_at",
    }
  ];

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY.MM.DD';
  const getPagination = async (
    page: number,
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string
  ) => {
    setLoading(true);
    try {
      const temp = await ShippingServices.getPaging({
        productName,
        page,
        fieldSearch,
        sort,
        fromDt,
        toDt
      });
      let list = temp.data.map((item: any, index: number) => {
        return {
          ...item,
          updated_at: formatDateTime(item.updated_at),
          // updated_at: moment(item.updated_at)
          //   .utc(true ?? 9)
          //   .format('YYYY.MM.DD hh:mm:ss A'),
          no: index + 1,
          statusSeller: getStatusSeller(item?.sellerStatus),
          key: item.id
        };
      });
      setList(list);
      setTotalPages(temp.meta.totalPages ?? 0);
      setCurrentPage(temp.meta.currentPage ?? 1);
      setTotaItem(temp.meta.totalItems ?? 0);
      setLoading(false);
    } catch (e) {
      setList([]);
      setTotalPages(0);
      setCurrentPage(1);
      setTotaItem(0);
      setLoading(false);
    }
  };


  useEffect(() => {
    getPagination(1, proName, valueSearch, sort, fromDt, toDt);
  }, [debounc, proName, sort, fromDt, toDt]);

  const handelExportExcel = async (
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string
  ) => {
    if (selectedRowKeys.length > 0) {
      let selected = selectedRowKeys.map((item) => Number(item));
      const responseById = await ShippingServices.exportExcelById(selected);
      const outputFilename = `OrderShipping_${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([responseById]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await ShippingServices.exportExcel({
        fieldSearch,
        productName,
        sort,
        fromDt,
        toDt
      });
      const outputFilename = `OrderShipping_${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };
  const getProductName = (e: any) => {
    setProName(e.key);
    setLabelType({ key: e.key, label: e.domEvent.target.innerText });
  };
  const onChangeState = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDate = (value: [string, string]) => {
    setDateValue(value);
  };
  const listLabel = [
    {
      id: 1,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getProductName}
          items={[
            {
              label: '주문 번호',
              key: 'no'
            },
            {
              type: 'divider'
            },
            {
              label: '주문 자명',
              key: 'buyerName'
            }
          ]}
        />
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeyss: React.Key[], selectedRows: DataType[]) => {
      // setListExcel(selectedRows);
      setSelectedRowKeys(selectedRowKeyss);
    },
    getCheckboxProps: (record: DataType) => ({
      // disabled: record.productName === "Disabled User", // Column configuration not to be checked
      name: record.productName
    })
  };

  return (
    <>
      <BreadcrumbList listBreadcrumb={listBreadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          ></div>
          <div className="control">
            <RangePicker
              onChange={(date: any, dateString: [string, string]) => {
                getDate(dateString);
              }}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              // defaultValue={[
              //   moment(moment(), dateFormat),
              //   moment(moment(), dateFormat),
              // ]}
              format={dateFormat}
            />
            {listLabel.map((item) => {
              return (
                <DropdownButton
                  key={item.id}
                  label={labelType.label}
                  menu={item.listMenu}
                />
              );
            })}
            <SearchBox
              type
              onChange={(e: any) =>
                onChangeState('Value Search', e.target.value)
              }
            />
          </div>
          <div className="table">
            <div>
              <div
                style={{
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 16
                }}
              >
                <div className="table__head">
                  <span style={{ marginLeft: 8 }}>총 상품 {totalItem}</span>
                  <span className="table__head --right">
                    선택 상품
                    {selectedRowKeys.length}
                  </span>
                </div>

                <div>
                  <Button
                    className="downExcel"
                    onClick={() => {
                      handelExportExcel(
                        valueSearch,
                        proName,
                        sort,
                        fromDt,
                        toDt
                      );
                    }}
                  >
                    {t('common:download')}
                  </Button>
                </div>
              </div>
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                rowSelection={rowSelection}
                pagination={{
                  total: totalPages * 10,
                  current: currentPage,
                  showSizeChanger: false,
                  onChange: (page, limit) => {
                    getPagination(
                      page,
                      valueSearch,
                      proName,
                      sort,
                      fromDt,
                      toDt
                    );
                  }
                }}
                onRow={(item) => {
                  return {
                    onClick: () => {
                      history.push(`/admin/seller/shipping/${item.key}`);
                    }
                  };
                }}
              />
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default Shipping;
